"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("@shared/views/BaseView");
var models_1 = require("@shared/models");
var DeckItemList_vue_1 = __importDefault(require("@client/views/products/decks/DeckItemList.vue"));
var CompanyYearList_vue_1 = __importDefault(require("./CompanyYearList.vue"));
var CompanyDecks = /** @class */ (function (_super) {
    __extends(CompanyDecks, _super);
    function CompanyDecks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = new models_1.PagedResult();
        _this.criteria = new models_1.DeckSearchRequest({ pageIndex: 0, pageSize: 40, sortBy: 'year', sortDirection: 'asc' });
        _this.yearList = [];
        _this.showYearList = false;
        _this.sortColumnOptions = [
            { text: 'Year', value: 'year' },
            { text: 'Name', value: 'name' },
            { text: 'Season', value: 'season' },
            { text: 'Created Date', value: 'createddate' },
            { text: 'Last Updated', value: null },
        ];
        _this.sortDirectionOptions = [
            { text: 'Asc', value: 'asc' },
            { text: 'Desc', value: 'desc' },
        ];
        return _this;
    }
    CompanyDecks.prototype.watchModelId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Refresh the data in this list */
    CompanyDecks.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, year, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.modelId) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        this.criteria = new models_1.DeckSearchRequest(this.$route.query);
                        // PUT THIS BACK IN HERE SINCE WE REMOVED IT FROM THE URL
                        this.criteria.sortBy = 'year';
                        this.criteria.pageSize = 56;
                        this.criteria.sortDirection = 'asc';
                        this.criteria.companyIds = [this.modelId];
                        _a = this;
                        return [4 /*yield*/, this.$api.deckService.search(this.criteria)];
                    case 2:
                        _a.list = _b.sent();
                        this.showYearList = false;
                        if (this.list.pager.totalResults > this.settings.minDecksForYearList) {
                            this.showYearList = true;
                        }
                        this.yearList = [];
                        if (this.list.pager.earliestYear && this.list.pager.latestYear) {
                            for (year = this.list.pager.earliestYear; year <= this.list.pager.latestYear; year++) {
                                this.yearList.push(year);
                            }
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        this.errorHandler.handle(err_1, 'An error occurred while loading this companies deck list');
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when a year is selected */
    CompanyDecks.prototype.yearSelected = function (year) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.criteria.startYear = year;
                        this.criteria.endYear = year;
                        return [4 /*yield*/, this.filter(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Fires the clear year button is clicked */
    CompanyDecks.prototype.clearYear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.criteria.startYear = null;
                        this.criteria.endYear = null;
                        return [4 /*yield*/, this.filter(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the page is changed */
    CompanyDecks.prototype.pageChanged = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.criteria.pageIndex = (page - 1);
                        return [4 /*yield*/, this.filter(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Applies the specified filter and redirects to the new page with the correct query parameters */
    CompanyDecks.prototype.filter = function (resetPage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.scroll.scrollToTop();
                        if (resetPage) {
                            this.criteria.pageIndex = 0;
                        }
                        // REMOVE THIS HERE SO IT DOESN'T SHOW UP IN THE URL
                        this.criteria.companyIds = [];
                        this.$router.push({ name: 'company-decks', params: { id: this.modelId }, query: this.criteria.collapse() }).catch(function () { });
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        vue_property_decorator_1.Prop()
    ], CompanyDecks.prototype, "modelId", void 0);
    __decorate([
        vue_property_decorator_1.Watch('modelId')
    ], CompanyDecks.prototype, "watchModelId", null);
    __decorate([
        vue_property_decorator_1.Watch('$route', { immediate: true, deep: true })
    ], CompanyDecks.prototype, "refresh", null);
    CompanyDecks = __decorate([
        vue_property_decorator_1.Component({
            components: {
                DeckItemList: DeckItemList_vue_1.default,
                CompanyYearList: CompanyYearList_vue_1.default,
            },
        })
    ], CompanyDecks);
    return CompanyDecks;
}(BaseView_1.BaseView));
exports.default = CompanyDecks;
